import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Descarga el mapa y las plantillas inmediatamente después de tu compra.'
  }, {
    num: '2',
    text: 'Identifica los errores en tus reportes gratuitos siguiendo la guía de auditoría.'
  }, {
    num: '3',
    text: 'Envía las cartas de disputa pre-redactadas por correo certificado y espera tus resultados en 30-45 días.'
  }];
  return <section className="py-24 bg-navy text-white" data-id="element-71">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <FadeIn data-id="element-73">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-74">
            Cómo Funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-75">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-0.5 bg-navy-light z-0" data-id="element-76"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="relative z-10" data-id="element-77">
              <div className="flex flex-col items-center text-center" data-id="element-78">
                <div className="w-16 h-16 rounded-full bg-gold text-navy flex items-center justify-center text-2xl font-bold mb-6 shadow-lg shadow-gold/20" data-id="element-79">
                  {step.num}
                </div>
                <p className="text-gray-300 font-sans leading-relaxed text-lg" data-id="element-80">
                  {step.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}